/**
 * Cache busting utilities for forcing client-side cache refresh
 */

/**
 * Clear all caches and reload the page
 */
export const clearAllCaches = async () => {
  try {
    // Clear all Cache Storage (Service Worker caches)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
      console.log('All caches cleared');
    }

    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    console.log('Browser storage cleared');
  } catch (error) {
    console.error('Error clearing caches:', error);
  }
};

/**
 * Check if app version has changed and clear cache if needed
 */
export const checkAndClearCache = () => {
  const currentVersion = process.env.REACT_APP_VERSION || '1.0.0';
  const storedVersion = localStorage.getItem('app-version');

  if (storedVersion && storedVersion !== currentVersion) {
    console.log(`Version changed from ${storedVersion} to ${currentVersion}. Clearing cache...`);
    clearAllCaches().then(() => {
      localStorage.setItem('app-version', currentVersion);
      window.location.reload(true);
    });
  } else if (!storedVersion) {
    localStorage.setItem('app-version', currentVersion);
  }
};

/**
 * Force reload the page, bypassing cache
 */
export const hardReload = () => {
  window.location.reload(true);
};
